// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* src/components/timetable.scss */
.timetable-card {
  padding: 12px 2px 4px 2px;
  min-height: 160px;
  overflow-x: auto;
  position: relative;
}

.timetable-month-swipe-area {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 18px 18px 0 0;
  padding-top: 10px;
  padding-bottom: 6px;
}

.timetable-month {
  font-size: 1.07rem;
  font-weight: 600;
  text-align: center;
  color: #232137;
  margin-bottom: 4px;
  font-family: "Cera Pro", Arial, sans-serif;
}

.timetable-month-loading {
  text-align: center;
  color: #667085;
  font-size: 0.8rem;
  margin-bottom: 4px;
}

/* table & sticky columns */
.timetable-wrapper {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative; /* для градиента */
}

.timetable-wrapper::-webkit-scrollbar {
  display: none;
}

/* градиент при свернутом состоянии */
.timetable-wrapper.has-more.is-collapsed .timetable-fade {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 44px; /* место под кнопку */
  height: 56px;
  pointer-events: none;
  content: "";
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff 70%);
  border-bottom: 1px solid #f1f1f1;
  border-top: 1px solid transparent;
}

.timetable {
  width: 100%;
  border-collapse: collapse;
  min-width: 900px;
  font-size: 0.98rem;
  font-family: "Cera Pro", Arial, sans-serif;
  background: none;
  margin-bottom: 0;
}

.timetable th,
.timetable td {
  border: 1px solid #f1f1f1;
  text-align: center;
  padding: 10px 6px; /* было 6px 2px → стало больше */
  min-width: 52px; /* немного шире */
  background: #fff;
  transition: background 0.13s;
}

.timetable th:first-child,
.timetable td:first-child,
.sticky-col {
  background: white;
  text-align: left;
  padding-left: 10px; /* было 6px */
  min-width: 95px; /* было 75px */
  color: #232137;
  font-weight: 600;
  border-left: none;
  position: sticky;
  left: 0;
  z-index: 5;
}

.timetable th {
  color: #bcbcbc;
  font-weight: 500;
  font-size: 0.96rem;
  border-top: none;
  border-bottom: 2px solid #f1f1f1;
  vertical-align: bottom;
  padding-bottom: 2px;
}

.timetable th div {
  font-size: 1.01rem;
  font-weight: 700;
  color: #232137;
}

.timetable th span {
  display: block;
  font-size: 0.92em;
  color: #bcbcbc;
  margin-top: 1px;
  font-weight: 400;
  letter-spacing: 0.01em;
}

.timetable-weekend div,
.timetable-weekend span {
  color: #e72f44 !important;
  font-weight: 700;
}

.cell-time {
  display: inline-block;
  font-size: 0.95rem; /* чуть крупнее */
  font-weight: 500;
  line-height: 1.25;
  color: #e72f44;
  background: rgba(231, 47, 68, 0.07);
  border-radius: 4px;
  padding: 4px 10px; /* было 2px 7px */
  margin: 4px 0 0 0; /* было 2px */
  letter-spacing: 0.01em;
  box-shadow: 0 2px 6px 0 rgba(36, 41, 57, 0.06);
}

.timetable tbody tr td:not(:first-child) {
  background: none;
  border-left: none;
  border-right: none;
}

.timetable tbody tr td:first-child {
  font-weight: 700;
  color: #232137;
}

.timetable tbody tr:last-child td {
  border-bottom: none;
}

.cell-selected {
  outline: 2px solid #e72f44;
  background: rgba(255, 224, 102, 0.1333333333) !important;
  z-index: 2;
  position: relative;
  transition: outline 0.11s, background 0.13s;
}

/* --- модалки --- */
.timetable-modal-overlay {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(36, 41, 57, 0.16);
  z-index: 1100;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.timetable-modal-sheet {
  box-shadow: 0 -2px 24px rgba(36, 41, 57, 0.13);
  background: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 100%;
  max-width: 480px;
  min-width: 240px;
  padding: 0;
}

.timetable-modal-sheet-large {
  height: 80vh !important;
  border-top-left-radius: 22px;
  border-top-right-radius: 22px;
  padding-bottom: 16px;
  padding-top: 22px;
  overflow-y: auto;
}

.timetable-modal-sheet-modern {
  padding: 28px 22px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.timetable-modal-title {
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 2px;
  letter-spacing: 0.01em;
  color: #232137;
}

.timetable-modal-label {
  font-size: 1.08rem;
  font-weight: 500;
  color: #232137;
  margin-bottom: 6px;
}

/* --- Современная форма --- */
.timetable-periods-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.timetable-period-card {
  background: #f6f8fa;
  border-radius: 16px;
  padding: 18px 16px 14px 16px; /* больше воздуха */
  margin-bottom: 4px;
  box-shadow: 0 2px 9px 0 rgba(36, 41, 57, 0.05);
  display: flex;
  flex-direction: column;
  gap: 10px; /* между строками */
}

.timetable-input-group {
  display: flex;
  align-items: center;
  gap: 12px; /* между label и инпутами */
}

.timetable-input-group label {
  font-size: 0.98rem;
  color: #232137;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}

.timetable-input-group input[type=time] {
  border: 1px solid #cfd1e0;
  border-radius: 8px;
  padding: 8px 11px; /* было 6px 9px */
  font-size: 1.08rem; /* крупнее */
  font-family: inherit;
  background: #fff;
  outline: none;
  min-width: 80px; /* чуть шире */
  margin-left: 2px;
  margin-right: 2px;
  transition: border 0.14s;
}

.timetable-input-group input[type=time]:focus {
  border: 1.5px solid #e72f44;
}

.timetable-checkbox-row {
  justify-content: space-between;
  margin-top: 2px;
}

.modern-checkbox {
  display: flex;
  align-items: center;
  gap: 10px; /* было 7px */
  font-size: 1rem;
  font-weight: 500;
  color: #232137;
  -webkit-user-select: none;
          user-select: none;
}

.modern-checkbox input[type=checkbox] {
  width: 18px;
  height: 18px;
  accent-color: #e72f44;
  margin-right: 2px;
}

.timetable-remove-btn {
  border: none;
  background: none;
  color: #e72f44;
  font-size: 1.26rem;
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 7px 1px 7px;
  cursor: pointer;
  transition: background 0.11s;
}

.timetable-remove-btn:active {
  background: #f0e2e2;
}

/* --- Кнопки --- */
.timetable-btn {
  background: #f4f5fa;
  border: none;
  border-radius: 16px;
  padding: 13px 22px; /* больше внутренний отступ */
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 2px;
  cursor: pointer;
  transition: background 0.12s;
  box-shadow: 0 2px 10px 0 rgba(36, 41, 57, 0.07);
}

.timetable-btn:active {
  background: #e6e7ee;
}

.timetable-btn.main {
  background: #e72f44;
  color: #fff;
  font-weight: 700;
}

.timetable-btn.add-period {
  background: #f8eaea;
  color: #e72f44;
  font-weight: 700;
  margin-top: 7px;
  margin-bottom: 0;
}

.timetable-btn.save-btn {
  background: #232137;
  color: #fff;
  border-radius: 22px;
  font-size: 1.2rem;
  padding: 16px 0; /* увеличить высоту */
  margin-top: 12px;
}

/* --- Пагинация --- */
.pagination {
  text-align: center;
  margin-top: 8px;
}

.pagination span {
  display: inline-block;
  width: 8px;
  height: 8px;
  background: #e6e6ee;
  border-radius: 50%;
  margin: 0 2px;
}

.pagination .active {
  background: #232137;
}

/* --- Тогглер сворачивания --- */
.timetable-collapse {
  display: flex;
  justify-content: center;
  padding: 10px 6px 6px;
}

.collapse-toggle {
  background: #f4f5fa;
  border: none;
  border-radius: 16px;
  padding: 9px 14px;
  font-size: 0.98rem;
  font-weight: 700;
  color: #232137;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 2px 10px 0 rgba(36, 41, 57, 0.07);
}

.collapse-toggle .arrow {
  display: inline-block;
  transform: rotate(0deg);
  transition: transform 0.16s ease;
  font-size: 1.05rem;
  line-height: 1;
}

.collapse-toggle.expanded .arrow {
  transform: rotate(180deg);
}

/* --- Мобилка --- */
@media (max-width: 850px) {
  .timetable {
    min-width: 640px;
  }
}
@media (max-width: 600px) {
  .timetable-modal-sheet, .timetable-modal-sheet-large, .timetable-modal-sheet-modern {
    max-width: 100vw;
    min-width: 0;
    border-radius: 20px 20px 0 0;
    padding-left: 8px;
    padding-right: 8px;
  }
  .timetable-period-card {
    padding: 12px 7px 10px 7px;
  }
}
/* Убрать стрелки input[type="time"] для iOS/Safari */
input[type=time]::-webkit-clear-button,
input[type=time]::-webkit-inner-spin-button,
input[type=time]::-webkit-outer-spin-button {
  display: none;
  -webkit-appearance: none;
}

input[type=time] {
  appearance: textfield;
}

.timetable-today {
  background: rgba(255, 224, 102, 0.3333333333);
  border-bottom: 2px solid #e72f44 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/block/Timetable/timetable.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,kCAAA;AACA;EACE,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAEF;;AACA;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,4BAAA;EACA,iBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;AAGF;;AAAA;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAGF;;AAAA,2BAAA;AACA;EACE,gBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA,EAAA,kBAAA;AAGF;;AADA;EAAwC,aAAA;AAKxC;;AAHA,qCAAA;AACA;EACE,kBAAA;EACA,OAAA;EAAS,QAAA;EAAU,YAAA,EAAA,qBAAA;EACnB,YAAA;EACA,oBAAA;EACA,WAAA;EACA,wEAAA;EACA,gCAAA;EACA,iCAAA;AAQF;;AALA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gBAAA;AAQF;;AANA;;EAEE,yBAAA;EACA,kBAAA;EACA,iBAAA,EAAA,gCAAA;EACA,eAAA,EAAA,iBAAA;EACA,gBAAA;EACA,4BAAA;AASF;;AAPA;;;EAGE,iBAAA;EACA,gBAAA;EACA,kBAAA,EAAA,aAAA;EACA,eAAA,EAAA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,OAAA;EACA,UAAA;AAUF;;AARA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,sBAAA;EACA,mBAAA;AAWF;;AATA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAYF;;AAVA;EACE,cAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAaF;;AAXA;;EAEE,yBAAA;EACA,gBAAA;AAcF;;AAZA;EACE,qBAAA;EACA,kBAAA,EAAA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mCAAA;EACA,kBAAA;EACA,iBAAA,EAAA,iBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;EACA,8CAAA;AAeF;;AAbA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AAgBF;;AAdA;EACE,gBAAA;EACA,cAAA;AAiBF;;AAfA;EAAoC,mBAAA;AAmBpC;;AAlBA;EACE,0BAAA;EACA,wDAAA;EACA,UAAA;EACA,kBAAA;EACA,2CAAA;AAqBF;;AAlBA,oBAAA;AACA;EACE,eAAA;EACA,OAAA;EAAS,QAAA;EAAU,MAAA;EAAQ,SAAA;EAC3B,kCAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AAwBF;;AAtBA;EACE,8CAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAyBF;;AAvBA;EACE,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AA0BF;;AAxBA;EACE,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA2BF;;AAzBA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AA4BF;;AA1BA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA6BF;;AA1BA,8BAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA6BF;;AA3BA;EACE,mBAAA;EACA,mBAAA;EACA,4BAAA,EAAA,mBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA,EAAA,mBAAA;AA8BF;;AA5BA;EACE,aAAA;EACA,mBAAA;EACA,SAAA,EAAA,2BAAA;AA+BF;;AA7BA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAgCF;;AA9BA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA,EAAA,iBAAA;EACA,kBAAA,EAAA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA,EAAA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAiCF;;AA/BA;EACE,2BAAA;AAkCF;;AAhCA;EACE,8BAAA;EACA,eAAA;AAmCF;;AAjCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA,EAAA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;UAAA,iBAAA;AAoCF;;AAlCA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAqCF;;AAnCA;EACE,YAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,4BAAA;AAsCF;;AApCA;EAA+B,mBAAA;AAwC/B;;AAtCA,mBAAA;AACA;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA,EAAA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,4BAAA;EACA,+CAAA;AAyCF;;AAvCA;EAAwB,mBAAA;AA2CxB;;AA1CA;EACE,mBAAA;EACA,WAAA;EACA,gBAAA;AA6CF;;AA3CA;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AA8CF;;AA5CA;EACE,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA,EAAA,qBAAA;EACA,gBAAA;AA+CF;;AA5CA,sBAAA;AACA;EACE,kBAAA;EACA,eAAA;AA+CF;;AA7CA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAgDF;;AA9CA;EACE,mBAAA;AAiDF;;AA9CA,iCAAA;AACA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;AAiDF;;AA/CA;EACE,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,+CAAA;AAkDF;;AAhDA;EACE,qBAAA;EACA,uBAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;AAmDF;;AAjDA;EACE,yBAAA;AAoDF;;AAjDA,oBAAA;AACA;EACE;IAAa,gBAAA;EAqDb;AACF;AApDA;EACE;IACE,gBAAA;IACA,YAAA;IACA,4BAAA;IACA,iBAAA;IACA,kBAAA;EAsDF;EApDA;IAAyB,0BAAA;EAuDzB;AACF;AArDA,qDAAA;AACA;;;EAGE,aAAA;EACA,wBAAA;AAuDF;;AArDA;EAAqB,qBAAA;AAyDrB;;AAvDA;EACE,6CAAA;EACA,2CAAA;AA0DF","sourcesContent":["/* src/components/timetable.scss */\r\n.timetable-card {\r\n  padding: 12px 2px 4px 2px;\r\n  min-height: 160px;\r\n  overflow-x: auto;\r\n  position: relative;\r\n}\r\n\r\n.timetable-month-swipe-area {\r\n  cursor: grab;\r\n  user-select: none;\r\n  border-radius: 18px 18px 0 0;\r\n  padding-top: 10px;\r\n  padding-bottom: 6px;\r\n}\r\n.timetable-month {\n  font-size: 1.07rem;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  color: #232137;\r\n  margin-bottom: 4px;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\n}\n\n.timetable-month-loading {\n  text-align: center;\n  color: #667085;\n  font-size: 0.8rem;\n  margin-bottom: 4px;\n}\n\r\n/* table & sticky columns */\r\n.timetable-wrapper {\r\n  overflow-x: auto;\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n  position: relative; /* для градиента */\r\n}\r\n.timetable-wrapper::-webkit-scrollbar { display: none; }\r\n\r\n/* градиент при свернутом состоянии */\r\n.timetable-wrapper.has-more.is-collapsed .timetable-fade {\r\n  position: absolute;\r\n  left: 0; right: 0; bottom: 44px; /* место под кнопку */\r\n  height: 56px;\r\n  pointer-events: none;\r\n  content: \"\";\r\n  background: linear-gradient(to bottom, rgba(255,255,255,0), #fff 70%);\r\n  border-bottom: 1px solid #f1f1f1;\r\n  border-top: 1px solid transparent;\r\n}\r\n\r\n.timetable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  min-width: 900px;\r\n  font-size: 0.98rem;\r\n  font-family: 'Cera Pro', Arial, sans-serif;\r\n  background: none;\r\n  margin-bottom: 0;\r\n}\r\n.timetable th,\r\n.timetable td {\r\n  border: 1px solid #f1f1f1;\r\n  text-align: center;\r\n  padding: 10px 6px;   /* было 6px 2px → стало больше */\r\n  min-width: 52px;    /* немного шире */\r\n  background: #fff;\r\n  transition: background 0.13s;\r\n}\r\n.timetable th:first-child,\r\n.timetable td:first-child,\r\n.sticky-col {\r\n  background: white;\r\n  text-align: left;\r\n  padding-left: 10px;  /* было 6px */\r\n  min-width: 95px;     /* было 75px */\r\n  color: #232137;\r\n  font-weight: 600;\r\n  border-left: none;\r\n  position: sticky;\r\n  left: 0;\r\n  z-index: 5;\r\n}\r\n.timetable th {\r\n  color: #bcbcbc;\r\n  font-weight: 500;\r\n  font-size: 0.96rem;\r\n  border-top: none;\r\n  border-bottom: 2px solid #f1f1f1;\r\n  vertical-align: bottom;\r\n  padding-bottom: 2px;\r\n}\r\n.timetable th div {\r\n  font-size: 1.01rem;\r\n  font-weight: 700;\r\n  color: #232137;\r\n}\r\n.timetable th span {\r\n  display: block;\r\n  font-size: 0.92em;\r\n  color: #bcbcbc;\r\n  margin-top: 1px;\r\n  font-weight: 400;\r\n  letter-spacing: 0.01em;\r\n}\r\n.timetable-weekend div,\r\n.timetable-weekend span {\r\n  color: #e72f44 !important;\r\n  font-weight: 700;\r\n}\r\n.cell-time {\r\n  display: inline-block;\r\n  font-size: 0.95rem; /* чуть крупнее */\r\n  font-weight: 500;\r\n  line-height: 1.25;\r\n  color: #e72f44;\r\n  background: rgba(231,47,68,0.07);\r\n  border-radius: 4px;\r\n  padding: 4px 10px;  /* было 2px 7px */\r\n  margin: 4px 0 0 0; /* было 2px */\r\n  letter-spacing: 0.01em;\r\n  box-shadow: 0 2px 6px 0 rgba(36,41,57,0.06);\r\n}\r\n.timetable tbody tr td:not(:first-child) {\r\n  background: none;\r\n  border-left: none;\r\n  border-right: none;\r\n}\r\n.timetable tbody tr td:first-child {\r\n  font-weight: 700;\r\n  color: #232137;\r\n}\r\n.timetable tbody tr:last-child td { border-bottom: none; }\r\n.cell-selected {\r\n  outline: 2px solid #e72f44;\r\n  background: #ffe06622 !important;\r\n  z-index: 2;\r\n  position: relative;\r\n  transition: outline 0.11s, background 0.13s;\r\n}\r\n\r\n/* --- модалки --- */\r\n.timetable-modal-overlay {\r\n  position: fixed;\r\n  left: 0; right: 0; top: 0; bottom: 0;\r\n  background: rgba(36,41,57,0.16);\r\n  z-index: 1100;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n}\r\n.timetable-modal-sheet {\r\n  box-shadow: 0 -2px 24px rgba(36,41,57,0.13);\r\n  background: #fff;\r\n  border-top-left-radius: 20px;\r\n  border-top-right-radius: 20px;\r\n  width: 100%;\r\n  max-width: 480px;\r\n  min-width: 240px;\r\n  padding: 0;\r\n}\r\n.timetable-modal-sheet-large {\r\n  height: 80vh !important;\r\n  border-top-left-radius: 22px;\r\n  border-top-right-radius: 22px;\r\n  padding-bottom: 16px;\r\n  padding-top: 22px;\r\n  overflow-y: auto;\r\n}\r\n.timetable-modal-sheet-modern {\r\n  padding: 28px 22px 22px 22px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n.timetable-modal-title {\r\n  font-size: 1.15rem;\r\n  font-weight: 700;\r\n  margin-bottom: 2px;\r\n  letter-spacing: 0.01em;\r\n  color: #232137;\r\n}\r\n.timetable-modal-label {\r\n  font-size: 1.08rem;\r\n  font-weight: 500;\r\n  color: #232137;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n/* --- Современная форма --- */\r\n.timetable-periods-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n.timetable-period-card {\r\n  background: #f6f8fa;\r\n  border-radius: 16px;\r\n  padding: 18px 16px 14px 16px; /* больше воздуха */\r\n  margin-bottom: 4px;\r\n  box-shadow: 0 2px 9px 0 rgba(36,41,57,0.05);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px; /* между строками */\r\n}\r\n.timetable-input-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;   /* между label и инпутами */\r\n}\r\n.timetable-input-group label {\r\n  font-size: 0.98rem;\r\n  color: #232137;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n.timetable-input-group input[type=\"time\"] {\r\n  border: 1px solid #cfd1e0;\r\n  border-radius: 8px;\r\n  padding: 8px 11px;  /* было 6px 9px */\r\n  font-size: 1.08rem; /* крупнее */\r\n  font-family: inherit;\r\n  background: #fff;\r\n  outline: none;\r\n  min-width: 80px;    /* чуть шире */\r\n  margin-left: 2px;\r\n  margin-right: 2px;\r\n  transition: border 0.14s;\r\n}\r\n.timetable-input-group input[type=\"time\"]:focus {\r\n  border: 1.5px solid #e72f44;\r\n}\r\n.timetable-checkbox-row {\r\n  justify-content: space-between;\r\n  margin-top: 2px;\r\n}\r\n.modern-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;   /* было 7px */\r\n  font-size: 1rem;\r\n  font-weight: 500;\r\n  color: #232137;\r\n  user-select: none;\r\n}\r\n.modern-checkbox input[type=\"checkbox\"] {\r\n  width: 18px;\r\n  height: 18px;\r\n  accent-color: #e72f44;\r\n  margin-right: 2px;\r\n}\r\n.timetable-remove-btn {\r\n  border: none;\r\n  background: none;\r\n  color: #e72f44;\r\n  font-size: 1.26rem;\r\n  font-weight: 700;\r\n  border-radius: 6px;\r\n  padding: 2px 7px 1px 7px;\r\n  cursor: pointer;\r\n  transition: background 0.11s;\r\n}\r\n.timetable-remove-btn:active { background: #f0e2e2; }\r\n\r\n/* --- Кнопки --- */\r\n.timetable-btn {\r\n  background: #f4f5fa;\r\n  border: none;\r\n  border-radius: 16px;\r\n  padding: 13px 22px; /* больше внутренний отступ */\r\n  font-size: 1.1rem;\r\n  font-weight: 600;\r\n  margin: 0 2px;\r\n  cursor: pointer;\r\n  transition: background 0.12s;\r\n  box-shadow: 0 2px 10px 0 rgba(36,41,57,0.07);\r\n}\r\n.timetable-btn:active { background: #e6e7ee; }\r\n.timetable-btn.main {\r\n  background: #e72f44;\r\n  color: #fff;\r\n  font-weight: 700;\r\n}\r\n.timetable-btn.add-period {\r\n  background: #f8eaea;\r\n  color: #e72f44;\r\n  font-weight: 700;\r\n  margin-top: 7px;\r\n  margin-bottom: 0;\r\n}\r\n.timetable-btn.save-btn {\r\n  background: #232137;\r\n  color: #fff;\r\n  border-radius: 22px;\r\n  font-size: 1.2rem;\r\n  padding: 16px 0;    /* увеличить высоту */\r\n  margin-top: 12px;\r\n}\r\n\r\n/* --- Пагинация --- */\r\n.pagination {\r\n  text-align: center;\r\n  margin-top: 8px;\r\n}\r\n.pagination span {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  background: #e6e6ee;\r\n  border-radius: 50%;\r\n  margin: 0 2px;\r\n}\r\n.pagination .active {\r\n  background: #232137;\r\n}\r\n\r\n/* --- Тогглер сворачивания --- */\r\n.timetable-collapse {\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 10px 6px 6px;\r\n}\r\n.collapse-toggle {\r\n  background: #f4f5fa;\r\n  border: none;\r\n  border-radius: 16px;\r\n  padding: 9px 14px;\r\n  font-size: 0.98rem;\r\n  font-weight: 700;\r\n  color: #232137;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  box-shadow: 0 2px 10px 0 rgba(36,41,57,0.07);\r\n}\r\n.collapse-toggle .arrow {\r\n  display: inline-block;\r\n  transform: rotate(0deg);\r\n  transition: transform 0.16s ease;\r\n  font-size: 1.05rem;\r\n  line-height: 1;\r\n}\r\n.collapse-toggle.expanded .arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* --- Мобилка --- */\r\n@media (max-width: 850px) {\r\n  .timetable { min-width: 640px; }\r\n}\r\n@media (max-width: 600px) {\r\n  .timetable-modal-sheet, .timetable-modal-sheet-large, .timetable-modal-sheet-modern {\r\n    max-width: 100vw;\r\n    min-width: 0;\r\n    border-radius: 20px 20px 0 0;\r\n    padding-left: 8px;\r\n    padding-right: 8px;\r\n  }\r\n  .timetable-period-card { padding: 12px 7px 10px 7px; }\r\n}\r\n\r\n/* Убрать стрелки input[type=\"time\"] для iOS/Safari */\r\ninput[type=\"time\"]::-webkit-clear-button,\r\ninput[type=\"time\"]::-webkit-inner-spin-button,\r\ninput[type=\"time\"]::-webkit-outer-spin-button {\r\n  display: none;\r\n  -webkit-appearance: none;\r\n}\r\ninput[type=\"time\"] { appearance: textfield; }\r\n\r\n.timetable-today {\r\n  background: #ffe06655;\r\n  border-bottom: 2px solid #e72f44 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
